import Request from 'api/request';

const replacePathParams = (path, params) => {
  return path.replace(/:(\w+)/g, (_, key) => params[key] || `:${key}`);
};

export const DataProvider = () => {
  return {
    getList: ({ resource, pagination, filters, sorters, meta }) => {
      const { apiPrefix, params, ...config } = meta;

      // TODO: Create Generate Filters
      // TODO: Create Generate Sorters
      // TODO: Create Generate Pagination

      return Request.call({
        url: replacePathParams(resource, params),
        method: 'GET',
        apiPrefix,
        params: {
          ...pagination,
          ...filters,
          ...sorters,
        },
        ...config,
      });
    },
    getMany: () => {},
    create: ({ resource, variables, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(resource, params),
        method: 'POST',
        apiPrefix,
        data: variables,
        ...config,
      });
    },
    update: ({ resource, id, variables, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(`${resource}/:id`, {
          ...params,
          id,
        }),
        method: 'PUT',
        apiPrefix,
        data: variables,
        ...config,
      });
    },
    getOne: ({ resource, id, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(`${resource}/:id`, {
          ...params,
          id,
        }),
        method: 'GET',
        apiPrefix,
        ...config,
      });
    },
    download: ({ resource, pagination, filters, sorters, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(resource, params),
        method: 'GET',
        apiPrefix,
        params: {
          ...pagination,
          ...filters,
          ...sorters,
        },
        ...config,
      });
    },
  };
};
